import React from "react";

import FooterWrapperComponent from "./Content";

const Component = () => {
	return <FooterWrapperComponent />;
};

export default Component;